export default __webpack_public_path__ + "static/media/DentalFlakesCat.2e6253f1.png";